
<template>
  <div class="advertisementManage div-layout">
    <div class="advertisementManage-main">
      <!-- <module-title :title="`${productId==='C20'?'帮助管理':'用户协议管理'}`"> -->
      <module-title title="用户协议管理">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            新增协议
          </el-button>
        </div>
      </module-title>
      <div class="advertisementManage-main-contain">
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="协议编号：" prop="code">
            <el-input
              v-model="searchForm.code"
              name="id"
              placeholder="请输入协议编号"
              class="handle-form-input"
            />
          </el-form-item>
          <el-form-item label="产品终端：" prop="protocolTerminal">
            <el-select
              v-model="searchForm.protocolTerminal"
              name="productTerminal"
              size="medium"
              class="edit-form-input"
              @change="getUserTerminal"
            >
              <el-option v-if="terminaltypeArr.length>1" label="全部" value="" />
              <el-option
                v-for="item in terminaltypeArr"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="协议类型：" prop="protocolType">
            <el-select
              v-model="searchForm.protocolType"
              name="advertisementPosition"
              size="medium"
              class="edit-form-input"
              @change="getUserType"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in usertypeArr"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>

          <el-form-item style="margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <!-- <multiple-box :visible="isSelection" :selection-num="selectionNum">
          <span class="handle-span" @click="handleDdelete">批量删除</span>
        </multiple-box>-->
        <el-table
          v-loading="listLoading"
          :data="userProtocolList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <!-- <el-table-column type="selection" width="55" align="center" /> -->
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="协议编号" align="center" prop="code" />
          <el-table-column label="协议类型" prop="typeName" align="center" />
          <!-- <el-table-column label="产品终端" prop="terminalName" align="center" /> -->
          <el-table-column label="协议链接" prop="link" align="center" width="328">
            <template slot-scope="scope">
              <a :href="scope.row.link" class="link" target="_blank">{{ scope.row.link }}</a>
            </template>
          </el-table-column>
          <el-table-column label="最后修改时间" prop="updateDate" align="center" width="128" />
          <el-table-column label="状态" prop="publishStatus" align="center" width="128">
            <template slot-scope="scope">
              <span v-show="scope.row.publishStatus===1">未发布</span>
              <span v-show="scope.row.publishStatus===2">已上架</span>
              <span v-show="scope.row.publishStatus===3">已下架</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="350px">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="small"
                icon="el-icon-view"
                @click="opAddOrEdit('view',scope.row)"
              >
                预览
              </el-button>

              <el-button
                v-show="scope.row.publishStatus===1"
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="opAddOrEdit('edit',scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-show="scope.row.publishStatus===3"
                type="danger"
                size="small"
                icon="el-icon-del"
                @click="handleDelete('one',scope.row)"
              >
                删除
              </el-button>
              <el-button
                v-show="scope.row.publishStatus===1"
                type="primary"
                size="small"
                @click="handlePublish('up',scope.row)"
              >
                发布
              </el-button>

              <el-button
                v-show="scope.row.publishStatus===3"
                type="primary"
                size="small"
                :disabled="true"
              >
                上架
              </el-button>
              <el-button
                v-show="scope.row.publishStatus===2"
                type="primary"
                size="small"
                @click="handlePublish('down',scope.row)"
              >
                下架
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增编辑广告 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="handleTitle"
      width="960px"
    >
      <div class="dialogMain">
        <el-form
          ref="handleForm"
          :model="handleForm"
          :rules="handleRules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="产品终端：" prop="terminalCode">
            <el-select
              v-if="!viewshow"
              v-model="handleForm.terminalCode"
              name="type"
              size="medium"
              class="handle-form-input"
              @change="handleTerminalCode"
            >
              <el-option
                v-for="item in terminaltypeArr"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
            <span v-else class="viewcontent">{{ handleForm.terminalName }}</span>
          </el-form-item>

          <el-form-item label="协议类型：" prop="typeId">
            <el-select
              v-if="!viewshow"
              v-model="handleForm.typeId"
              name="type"
              size="medium"
              class="handle-form-input"
              @change="handleType"
            >
              <el-option
                v-for="item in usertypeArr"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
            <span v-else class="viewcontent">{{ handleForm.typeName }}</span>
          </el-form-item>
          <!-- <el-form-item label=" 协议链接：" prop="link">
            <el-input
              v-if="!viewshow"
              v-model="handleForm.link"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              class="handle-form-input"
            ></el-input>
            <span v-else class="viewcontent">{{handleForm.link}}</span>
          </el-form-item>-->
          <el-form-item label=" 协议内容：" prop="content">
            <Editor
              v-if="!viewshow"
              :editor-content="handleForm.content"
              :decimal-num="20000"
              @editorChange="editorChangeFn"
            />
            <span v-else class="viewcontent ql-editor" v-html="handleForm.content" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">
          取消
        </el-button>
        <el-button
          v-if="!viewshow"
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddSubject"
        >
          {{ ajaxLoading?'Loading':'保存' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// import MultipleBox from "@/components/MultipleBox";
// import { validateUserName } from '@/utils/validate';
import { mapGetters } from 'vuex';

import {
  demandsensitivewordsCheck
} from '@/api/systemManage/sensitiveManage';
// 获取API
import {
  getUserProtocolAdd,
  getUserProtocolEdit,
  getUserProtocolInfos,
  getDictsType,
  agreementmanagesPublish,
  agreementmanagesBatch,
  getProtocolOne
} from '@/api/productOperation/public/userProtocolManage';
export default {
  name: 'UserProtocolManage',
  data() {
    return {
      ajaxLoading: false,
      // 弹框标题
      handleTitle: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        // 详情
        dialogDetailVisible: false // 详情标识
      },
      handleDialog: {
        type: 'add'
      },
      viewshow: false,
      // 搜索表单
      searchForm: {
        protocolTerminal: '',
        code: '',
        protocolType: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      // 操作表单
      handleForm: {
        typeId: '',
        // link: '',
        terminalCode: '',
        content: ''
      },
      handleRules: {
        terminalCode: [
          { required: true, message: '产品终端不能为空', trigger: 'blur' }
        ],
        typeId: [
          { required: true, message: '协议类型不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '协议内容不能为空', trigger: 'blur' }
        ]
      },
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选,
      userProtocolList: [],
      usertypeArr: [],
      terminaltypeArr: [],
      usertype: 'protocol_type'
      // terminaltype: 'terminal_type'
    };
  },
  computed: {
    ...mapGetters(['currentProdeuctId'])
  },
  mounted() {
    this.getType();
  },
  props: {
    productId: {
      type: String
    }
  },
  methods: {
    // 获取类型列表 裴远 韩语汐
    getType() {
      // var option = {
      //   pageNum: 1,
      //   pageSize: 999
      // };
      // getDictsType(this.terminaltype).then(res => {
      //   this.terminaltypeArr = res.data;
      // });
      this.getTerminaltypeArr();
      getDictsType(this.usertype).then(res => {
        this.usertypeArr = res.data;
      });
      this.listLoading = true;
      this.getInfo();
    },
    getTerminaltypeArr() {
      switch (this.productId) {
        case 'S01':
          this.terminaltypeArr = [{ code: 'C12', name: '新云网服务' }];
          break;
        case 'C13':
          this.terminaltypeArr = [{ code: 'C01', name: '课桌先生' }, { code: 'A02', name: '优智多家长端' }];
          break;
        case 'B14':
          this.terminaltypeArr = [{ code: 'B21', name: '教师授课助手' }];
          break;
        case 'B11':
          this.terminaltypeArr = [{ code: 'A01', name: '智联家校圈' }, { code: 'A23', name: '小程序端' }];
          break;
        case 'C10':
          this.terminaltypeArr = [{ code: 'C04', name: '优智多课堂' }];
          break;
        case 'C11':
          this.terminaltypeArr = [{ code: 'A09', name: '优智多商城' }];
          break;
        case 'C15':
          this.terminaltypeArr = [{ code: 'C21', name: '班务助手值日生' }, { code: 'C22', name: '班务助手纪检' }, { code: 'C23', name: '微信小程序' }];
          break;
        default:
          break;
      }
      if (this.terminaltypeArr.length === 1) {
        this.searchForm.protocolTerminal = this.terminaltypeArr[0].code;
      }
    },
    // 获取列表
    getInfo() {
      var option = {
        code: this.searchForm.code,
        typeId: this.searchForm.protocolType,
        terminalCode: this.searchForm.protocolTerminal,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        typeCode: this.productId,
        productId: this.currentProdeuctId
      };
      getUserProtocolInfos(option)
        .then(res => {
          this.listLoading = false;
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.userProtocolList = [];
            this.searchForm.total = 0;
          } else {
            this.userProtocolList = res.data.list;
            this.searchForm.total = res.data.total;
          }
        })
        .catch(err => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.listLoading = false;
          console.log(err);
        });
    },
    editorChangeFn(val) {
      this.handleForm.content = val;
    },
    handleTerminalCode(val) {
      this.handleForm.terminalCode = val;
    },
    handleType(val) {
      this.handleForm.typeId = val;
    },
    getUserTerminal(val) {
      this.searchForm.protocolTerminal = val;
    },
    getUserType(val) {
      this.searchForm.protocolType = val;
    },

    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.listLoading = true;
      this.getInfo();
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      const data = row;
      this.ajaxLoading = false;
      if (type === 'add') {
        this.handleTitle = '新增用户协议';
        this.viewshow = false;
      } else if (type === 'edit') {
        this.handleTitle = '编辑用户协议';
        this.viewshow = false;
      } else {
        this.handleTitle = '查看用户协议';
        this.viewshow = true;
      }
      this.handleDialog.type = type;
      this.hiddenVariable.dialogEditVisible = true;
      if (type === 'add') {
        this.handleForm = {
          typeId: '',
          // link: "",
          terminalCode: this.terminaltypeArr.length === 1 ? this.terminaltypeArr[0].code : '',
          content: ''
        };
      } else {
        this.userProtocolOneInfo(data.id);
      }
    },
    userProtocolOneInfo(id) {
      getProtocolOne(id)
        .then(res => {
          this.listLoading = false;
          this.handleForm = {};
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.handleForm = {};
          } else {
            this.handleForm = res.data;
          }
        })
        .catch(err => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          console.log(err);
        });
    },
    // 删除
    handleDelete(val, row) {
      const noticeIds = [];
      const status = -1;
      if (val === 'one') {
        noticeIds.push(row.id);
      }
      this.$confirm(
        `确定要删除该条协议吗?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var option = {
            ids: noticeIds,
            status: status
          };
          agreementmanagesBatch(option).then(res => {
            this.$notify.success({
              title: 'Success',
              message: '删除成功',
              showClose: false,
              duration: 2000
            });
            this.listLoading = true;
            this.getInfo();
          });
        })
        .catch(() => {});
    },
    // 发布
    handlePublish(type, row) {
      var status = type === 'up' ? 2 : 3;
      var text = type === 'up' ? '发布' : '下架';
      this.$confirm(`确定要${text}该协议么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            ids: [row.id],
            status: status
          };
          return agreementmanagesPublish(form);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `${text}成功`,
            showClose: false,
            duration: 2000
          });
          this.getInfo();
        })
        .catch(() => { });
    },
    // 新增编辑学科
    handleAddSubject() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          var content = {
            content: this.handleForm.content
          };
          demandsensitivewordsCheck(content).then(response => {
            if (response.data && response.data.isChoose) {
              this.$message({
                type: 'warning',
                message: response.data.badword
              });
              return;
            } else {
              this.ajaxLoading = true;
              this.handleForm.typeCode = this.productId;
              this.handleForm.productId = this.currentProdeuctId;
              if (this.handleDialog.type === 'add') {
                getUserProtocolAdd(this.handleForm).then(res => {
                  this.$notify.success({
                    title: 'Success',
                    message: '新增成功',
                    showClose: false,
                    duration: 2000
                  });
                  this.hiddenVariable.dialogEditVisible = false;
                  this.listLoading = true;
                  this.ajaxLoading = false;
                  this.getInfo();
                }).catch(() => {
                  this.listLoading = false;
                  this.ajaxLoading = false;
                });
              } else {
                getUserProtocolEdit(this.handleForm).then(res => {
                  this.$notify.success({
                    title: 'Success',
                    message: '编辑成功',
                    showClose: false,
                    duration: 2000
                  });
                  this.hiddenVariable.dialogEditVisible = false;
                  this.listLoading = false;
                  this.ajaxLoading = false;
                  this.getInfo();
                }).catch(() => {
                  this.listLoading = false;
                  this.ajaxLoading = false;
                });
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose() {
      this.handleForm = {
        typeId: '',
        // link: "",
        terminalCode: '',
        content: ''
      };
      this.hiddenVariable.dialogEditVisible = false;
      this.getInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.advertisementManage {
  padding-bottom: 20px;
  // .advertisementManage-main {
  //   .advertisementManage-main-contain {
  //   }
  // }
}
.dialogMain {
  max-height: 400px;
  overflow-y: auto;
}
.link {
  color: #409eff;
  text-decoration: underline;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}

.upload-picture {
  float: right;
}

.picture-wrapper {
  width: 80%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
</style>
